import { Box, Flex, Heading, Image, Text, VStack, Link} from "@chakra-ui/react";
import { keyframes } from "@emotion/react"; 

import rootcanal from "../assets/root-canal.avif";
import implant from "../assets/dental-implants.avif";
import fillings from "../assets/dental-fillings.avif";
import wisdom from "../assets/wisdom-teeth-removal.avif";
import braces from "../assets/braces-and-aligners.avif";
import dentures from "../assets/dentures.avif";
import bridges from "../assets/bridges-and-crowns.avif";
import kids from "../assets/kids-dentistry.avif";
import ulcers from "../assets/mouth-ulcers.avif";

// Service data
const services = [
  { title: "Dental Fillings", description: "Dental fillings repair cavities...", image: fillings, link: "/dental-filling" },
  { title: "Wisdom Teeth Removal", description: "Wisdom teeth removal prevents pain...", image: wisdom, link: "/wisdom-teeth-removal" },
  { title: "Root Canal Treatment", description: "If you're experiencing severe pain...", image: rootcanal, link: "/root-canal-treatment" },
  { title: "Braces & Aligners", description: "Braces and aligners straighten teeth...", image: braces, link: "/braces-and-aligners" },
  { title: "Dental Implants", description: "Restore your smile with implants...", image: implant, link: "/dental-implants" },
  { title: "Dentures", description: "Dentures replace missing teeth...", image: dentures, link: "/dentures" },
  { title: "Bridges & Crowns", description: "Bridges and crowns restore teeth...", image: bridges, link: "/bridges-and-crowns" },
  { title: "Kids Dentistry", description: "Kids dentistry focuses on children...", image: kids, link: "/kids-dentistry" },
  { title: "Mouth Ulcers", description: "Mouth ulcers are small, painful sores...", image: ulcers, link: "/mouth-ulcers" },
];

// Keyframes for auto scroll
const scroll = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const DentalServices = () => {
  const scrollAnimation = `${scroll} 60s linear infinite`;

  // Duplicate services to allow seamless looping
  const scrollingServices = [...services, ...services];

  return (
    <Box bg="white" py={20} textAlign="center" id="service">
      <Heading
        as="h2"
        fontSize={{ md: "5xl", base: "2xl" }}
        mb={10}
        fontWeight="light"
      >
        All-in-one dental solutions, right here in one place
      </Heading>

      <Box overflow="hidden" width="100%">
        <Flex
          animation={scrollAnimation}
          width="max-content"
          whiteSpace="nowrap"
        >
          {scrollingServices.map((service, index) => (
            <Link
              href={service.link}
              _hover={{ textDecoration: "none" }}
              key={index}
              // The list is rendered twice to make the marquee loop seamlessly.
              // Hide the clones so screen readers and keyboard users get each
              // treatment exactly once.
              aria-hidden={index >= services.length}
              tabIndex={index >= services.length ? -1 : undefined}
              display="inline-block"
              minW="280px"
              maxW="280px"
              mx={2}
              flex="0 0 auto"
            >
              <VStack
                bg="white"
                textAlign="left"
                align="stretch"
                transition="all 0.3s ease-in-out"
                overflow="hidden"
                borderWidth="1px"
                borderRadius="md"
                _hover={{
                  transform: "scale(1.03)",
                  boxShadow: "lg",
                }}
              >
                <Image
                  src={service.image}
                  alt={`${service.title} at Qualiteeth Dental Care, Vaishali Nagar, Jaipur`}
                  objectFit="cover"
                  height="200px"
                  p="10px"
                  loading="lazy"
                />
                <Box p={4}>
                  <Heading as="h3" fontSize="lg" mb={2}>
                    {service.title}
                  </Heading>
                  <Text fontSize="sm" color="gray.600">
                    {service.description}
                  </Text>
                </Box>
              </VStack>
            </Link>
          ))}
        </Flex>
      </Box>
    </Box>
  );
};

export default DentalServices;
